import { writable } from 'svelte/store'

const config = writable({
  // backendURL:  "http://192.168.137.1:5000",
  backendURL: "https://motasystem.onrender.com",
  currentUser: null,
  full: true,
});

export default config;
